
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 18C3 9.716 9.615 3 17.775 3s14.776 6.716 14.776 15c0 8.284-6.615 15-14.776 15C9.615 33 3 26.284 3 18zm9.038-.154c.607-.216.967-.885.967-1.533 0-1.142-.885-1.862-2.407-1.862H7.286v6.995h3.517c1.574 0 2.51-.782 2.51-1.944 0-.751-.422-1.471-1.275-1.656zm2.108-3.703v7.303h1.677v-7.303h-1.677zm5.297 2.18c-1.584 0-2.746 1.122-2.746 2.623 0 1.523 1.162 2.633 2.746 2.633 1.574 0 2.736-1.11 2.736-2.633 0-1.501-1.162-2.623-2.736-2.623zm7.17.134v.247a2.465 2.465 0 00-1.368-.38c-1.348 0-2.48 1.018-2.48 2.54 0 1.347 1.132 2.407 2.48 2.407.555 0 .997-.134 1.368-.36v.596c0 .68-.443 1.029-1.008 1.029-.618 0-.967-.288-1.05-.75H22.91c.082 1.295 1.183 2.16 2.695 2.16 1.563 0 2.674-.906 2.674-2.47v-5.019h-1.666zm-16.283-.586c.669 0 1.019.236 1.019.679 0 .452-.36.781-1.019.781H9.024v-1.46h1.306zm.247 4.135H9.024v-1.41h1.584c.648 0 1.008.247 1.008.68 0 .41-.319.73-1.039.73zm8.866.185c-.71 0-1.182-.525-1.182-1.234 0-.69.473-1.235 1.182-1.235.7 0 1.173.545 1.173 1.235 0 .71-.473 1.234-1.173 1.234zm6.141-.247c-.679 0-1.183-.535-1.183-1.08 0-.72.504-1.173 1.183-1.173.36 0 .71.103 1.029.463v1.317c-.32.36-.669.473-1.029.473z","fill":"currentColor"}})])
          )
        }
      }
    